var _defs, _path, _path2, _path3, _g, _g2, _path4, _path5, _path6, _path7, _g3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTbLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 160.249,
    height: 52.492,
    viewBox: "0 0 160.249 52.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.335,
    y1: 0.43,
    x2: 1.333,
    y2: 0.975,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc9136"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fe404c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852d3b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.379,
    y1: 0.078,
    x2: 0.466,
    y2: 0.238,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#77101a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e91431"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.543,
    y1: 0.825,
    x2: 0.773,
    y2: 1.895,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b91d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd7c3e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.61,
    y1: 0.438,
    x2: 0.395,
    y2: 0.146,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#ab2318",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#e64530",
    stopOpacity: 0.157
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd5239",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M173.812,71.741c.141,2.354-5.272,7.34-5.272,7.34a22.547,22.547,0,0,1-15.23,5.335l1.025,3.537,3.2,3.006,4.535,2.025c6.324-1.783,14.2-8.7,13.817-15.87a9.61,9.61,0,0,0-1.85-5.093C173.964,71.925,173.891,71.831,173.812,71.741Z",
    transform: "translate(-153.31 -71.741)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2222d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e91431"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e0a15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e91431"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.393,
    y1: 0.222,
    x2: 0.656,
    y2: 0.739,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e0a15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70c1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.159,
    y1: 0.425,
    x2: 0.756,
    y2: 0.642,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e0a15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#831214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.186,
    y1: 0.418,
    x2: 0.596,
    y2: 0.805,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e0a15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6f0c0e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.163,
    y1: 0.5,
    x2: 0.854,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#400000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f53737"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -0.041,
    y1: 0.5,
    x2: 0.455,
    y2: 0.5,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.442,
    y1: 0.355,
    x2: 0.644,
    y2: 0.861,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.076,
    y1: 0.679,
    x2: 0.537,
    y2: 0.321,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#88111c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e91431"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.195,
    y1: 0.413,
    x2: 0.772,
    y2: 0.874,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e0a15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aa1223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e0a15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71070a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12186",
    "data-name": "Group 12186",
    transform: "translate(24482.131 10897.151)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M185.214,52.687s-1.846.427-1.846,1.749h1.846Z",
    transform: "translate(-24612.502 -10941.762)",
    fill: "#1c1b1b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M194.51,53.828c-.452-.716-1.663-1.9-2.481-1.687l-8.661,2.407v1.021a1.265,1.265,0,0,0,1.639,1.209Z",
    transform: "translate(-24612.502 -10941.873)",
    fill: "#1c1b1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(-24482.131 -10897.151)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M169.928,70.252c-.308-.268-.625-.519-.947-.758l-5.053,6.639c2.629,2.665,4.469,6.735,3.628,12.938,0,0,2.378-2.584,3.459-4.106a16.525,16.525,0,0,0,2.047-3.739C174.621,77.068,173.2,73.08,169.928,70.252Z",
    transform: "translate(-134.174 -41.322)",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(18.755 23.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M171.808,70.746a21.037,21.037,0,0,0-6.244-3.573c-.023-.01-.047-.018-.071-.026l-10.738,4.378c1.435.161,16.82,2.271,14.68,18.04,0,0,2.377-2.583,3.459-4.1a16.519,16.519,0,0,0,2.046-3.739C176.5,77.564,175.079,73.575,171.808,70.746Z",
    transform: "translate(-154.724 -65.246)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M163.658,66.786c-1.216-.421-2.446-.815-3.673-1.229l-5.12,2.113-.136,2.679Z",
    transform: "translate(-154.729 -65.557)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M170.469,70.159c-.074-.065-.152-.123-.227-.187q-.267.129-.54.238c-1.346.532-2.712,1.006-4.076,1.485-.79.277-1.576.567-2.361.856-.218.08-.337.121-.4.14s-.172.092-.384.195l-1.32.644c4.1,2.335,8.107,6.834,6.937,15.448,0,0,2.378-2.584,3.459-4.106a16.865,16.865,0,0,0,2.047-3.739C175.264,76.774,173.763,72.978,170.469,70.159Z",
    transform: "translate(-134.716 -41.228)",
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(17.058 30.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    transform: "translate(-0.517 1.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M175.347,72.91C166.5,82.315,159,83.153,159,83.153c.743,1,13.75,1.608,16.083-2.544.023-.042.039-.082.062-.124a17.143,17.143,0,0,0,.525-4.229A17.363,17.363,0,0,0,175.347,72.91Z",
    transform: "translate(-151.681 -72.91)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    transform: "translate(2.316 7.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M154.968,80.713c-.05-.042-.1-.081-.153-.124A1.769,1.769,0,0,0,154.968,80.713Z",
    transform: "translate(-154.815 -79.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M173.873,83.992a16.242,16.242,0,0,0,2-4.554c0-.053,0-.088,0-.088A58.1,58.1,0,0,1,158.6,81.975c-.146,0-.291-.006-.435-.014-.246-.011-.379-.02-.379-.02l-.084-.016a6.725,6.725,0,0,1-1.19-.253c-.166-.049-.314-.1-.454-.149-.024-.01-.049-.017-.072-.026a4.511,4.511,0,0,1-1.045-.539C159.938,85.113,171.728,85.554,173.873,83.992Z",
    transform: "translate(-154.79 -79.349)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(0.018 5.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M152.916,77.461c-.006-.039-.017-.075-.023-.115a3.921,3.921,0,0,0,.193.985c-.018-.073-.03-.148-.045-.222A4.482,4.482,0,0,1,152.916,77.461Z",
    transform: "translate(-152.893 -77.346)",
    fill: "#017276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M174.247,84.215c-13.094,1.755-19.111-3.172-19.111-3.172l-.027-.023c-.057-.043-.112-.092-.17-.139-.108-.088-.212-.177-.308-.268-.048-.045-.1-.09-.143-.136a5.612,5.612,0,0,1-1.432-2.308c2.262,9.491,15.283,10.175,17.9,9.8A16.647,16.647,0,0,0,174.247,84.215Z",
    transform: "translate(-152.862 -77.185)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    transform: "translate(0 4.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M152.878,77.029s0,.134.03.365C152.9,77.272,152.878,77.151,152.878,77.029Z",
    transform: "translate(-152.878 -77.029)",
    fill: "#017b80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M153.113,78.337a4.7,4.7,0,0,1-.157-.606c1.264,9.277,10.654,12.795,13.751,12.969h0a17.264,17.264,0,0,0,4.276-2.651C157.191,87.288,153.9,81.178,153.113,78.337Z",
    transform: "translate(-152.863 -76.892)",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M166.723,90.838c-10.249-2.5-12.926-9.425-13.613-12.41a4.585,4.585,0,0,1-.227-1.339l0-.06c.032.77.092,1.5.171,2.193.31,2.456,1.179,6.483,3.632,9.48l.023.027c.085.1.177.2.267.3a11.353,11.353,0,0,0,2.091,1.829,10.009,10.009,0,0,0,2.815,1.29,13.719,13.719,0,0,0,4.088-1C166.22,91.059,166.47,90.946,166.723,90.838Z",
    transform: "translate(-152.878 -72.104)",
    fill: "url(#linear-gradient-9)"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M146.291,65.059V61.136c-2.132-.453-6.616-1.076-7.2,1.553,0,0-.286,2.621,1.348,3.966s6.973-.537,6.973-.537V64.7l-.974,1.137Z",
    transform: "translate(-139.037 -43.037)",
    fill: "url(#linear-gradient-10)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M153.879,62.464",
    transform: "translate(-136.14 -42.697)",
    fill: "#009fa7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M163.646,98.04a8.913,8.913,0,0,1-2.677-2.119A29.375,29.375,0,0,1,158.2,92.67a16.538,16.538,0,0,1-2.312-4.822,20.491,20.491,0,0,1-.612-5.66V45.932h-1.363a7.865,7.865,0,0,0-7.866,7.866V85.727a12.551,12.551,0,0,0,1.967,6.7,13.122,13.122,0,0,0,5.088,4.632,12.549,12.549,0,0,0,4.339,1.291,17.231,17.231,0,0,0,3.18,0c.5-.038.992-.09,1.489-.135Z",
    transform: "translate(-137.673 -45.932)",
    fill: "url(#linear-gradient-11)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 9.217,
    height: 11.023,
    transform: "translate(8.374 26.938)",
    fill: "url(#linear-gradient-12)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M178.821,63a.38.38,0,0,1-.206.506h0l-1.027.413L176,64.559l-2.049.824-2.413.968-2.676,1.075-2.837,1.139-2.9,1.166-2.864,1.15c-.91.366-1.819.686-2.728,1.051-.83.334-1.469.607-2.3.941-.719.288-1.628.682-2.347.97l-1.719.691a11.368,11.368,0,0,1-4.029,1.063,8.9,8.9,0,0,1-1.71-.129,7.307,7.307,0,0,1-1.847-.579,6.585,6.585,0,0,1-1.774-1.227,7.582,7.582,0,0,1-1.486-2.071,11.613,11.613,0,0,1-.988-3.113,20.965,20.965,0,0,1-.275-4.352q.014-.452.041-.9s-.275,3.974,5.81,2.815a.326.326,0,0,0,.049-.012L168.6,58.4A8.357,8.357,0,0,1,178.821,63Z",
    transform: "translate(-139.043 -43.571)",
    fill: "url(#linear-gradient-13)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(0 19.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M140.442,64.807c-.053-.032-.1-.065-.151-.1l-.045-.031c-.045-.033-.09-.067-.132-.1l-.047-.038c-.039-.033-.076-.067-.112-.1l-.047-.045c-.034-.032-.066-.066-.1-.1l-.047-.053c-.027-.032-.054-.063-.079-.1s-.032-.041-.047-.061-.044-.06-.063-.09-.033-.05-.05-.077l-.047-.075c-.018-.032-.036-.065-.053-.1s-.02-.037-.03-.056c-.022-.044-.042-.088-.062-.133l-.007-.018a2.963,2.963,0,0,1-.226-.905,1.475,1.475,0,0,1-.013-.151V62.5c-.03.554-.041,1.077-.041,1.583L141.6,70.56l7.914,3.714c.554-.181,1.1-.395,1.648-.616l1.719-.691c.719-.288,1.628-.682,2.347-.97.656-.264,1.2-.49,1.8-.739l.065-.029c-12.3-2.045-14.842-4.645-16.645-6.415Z",
    transform: "translate(-139.042 -62.386)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M139.476,63.806l-.014-.029c-.044-.077-.083-.153-.117-.228-.007-.017-.017-.035-.024-.051-.032-.075-.06-.149-.084-.222l-.025-.077c-.019-.065-.036-.126-.05-.187-.007-.031-.014-.062-.02-.092-.01-.045-.017-.088-.024-.129,0-.017-.007-.035-.008-.05l.377,5.6c.047.193.1.377.149.558.01.037.019.074.03.11.041.139.086.269.13.4.037.11.074.22.115.329s.079.207.12.306q.106.258.226.509c.022.044.042.093.063.138l0,.006,6.222,3.965h.008c.19.007.38.012.57.008a10.817,10.817,0,0,0,3.826-.982l.183-.074C148.623,72.744,141.558,69.81,139.476,63.806Z",
    transform: "translate(-139.03 -62.336)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M146.669,74.73c-5.951-4.494-7.233-9.857-7.5-11.682a2.737,2.737,0,0,1-.072-.647C138.488,72.753,143.414,74.632,146.669,74.73Z",
    transform: "translate(-139.043 -62.402)",
    fill: "#5b090e"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M207.252,65.089a7.64,7.64,0,0,1-6.311,3.06,8.075,8.075,0,0,1,0-16.132,7.654,7.654,0,0,1,6.311,3V52.146h2.254v15.9h-.82a1.433,1.433,0,0,1-1.434-1.432Zm-3.556.348a5.817,5.817,0,0,0,3.359-3.947A5.85,5.85,0,1,0,195.532,60.1,5.854,5.854,0,0,0,203.7,65.437Z",
    transform: "translate(-24610.568 -10941.893)",
    fill: "#1c1b1b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M218.354,59.1a1.465,1.465,0,0,1-.226.193c2.223,3.638,4.218,6.954,5.989,9.884h-1.643a1.433,1.433,0,0,1-1.223-.687l-4.668-7.651L212.3,65.089v2.656a1.433,1.433,0,0,1-1.432,1.434h-.82V47.366a1.433,1.433,0,0,1,1.432-1.434h.788V56.364c.032,2.994.032,5.023.032,6.117q3.623-3.526,6.569-6.472l2.575-2.575h2.7C222.346,55.2,220.414,57.1,218.354,59.1Z",
    transform: "translate(-24607.281 -10943.083)",
    fill: "#1c1b1b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M236.546,65.089a7.639,7.639,0,0,1-6.311,3.06,8.075,8.075,0,0,1,0-16.132,7.653,7.653,0,0,1,6.311,3V52.146H238.8v15.9h-.82a1.433,1.433,0,0,1-1.434-1.432Zm-3.556.348a5.813,5.813,0,0,0,3.357-3.947A5.85,5.85,0,1,0,224.826,60.1,5.854,5.854,0,0,0,232.99,65.437Z",
    transform: "translate(-24604.838 -10941.893)",
    fill: "#1c1b1b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M244.208,53.434h4.83V55.3h-4.83V69.21h-2.22V55.3h-2.672V53.434h2.672V50.15c0-2.544,2.479-4.218,4.893-4.218a4.979,4.979,0,0,1,3.284,1.159L249.038,48.6a2.807,2.807,0,0,0-2.126-.966,2.767,2.767,0,0,0-2.7,2.575Z",
    transform: "translate(-24601.555 -10943.083)",
    fill: "#1c1b1b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M262.96,52.206h2.222v15.84h-.788a1.433,1.433,0,0,1-1.434-1.432V64.472a5.387,5.387,0,0,1-5.377,3.8A7.057,7.057,0,0,1,253.4,66.92a6.3,6.3,0,0,1-2.769-5.441V52.206h2.254v8.823a5.6,5.6,0,0,0,1.385,3.863,5.021,5.021,0,0,0,3.606,1.513,5.133,5.133,0,0,0,5.086-5.054Z",
    transform: "translate(-24599.342 -10941.855)",
    fill: "#1c1b1b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M266.061,65.567c0-3.381,0-6.729-.031-10.078v-8.1a1.432,1.432,0,0,1,1.432-1.434h.852c0,1.835-.032,3.8-.065,5.828-.032,2.222-.063,4.411-.063,6.632,0,2.125.031,4.249.128,6.311a3.962,3.962,0,0,0,.612,2.028,2.376,2.376,0,0,0,1.931.966,2.09,2.09,0,0,0,1.288-.386l.145.439a1.4,1.4,0,0,1-1.229,1.825c-.213.016-.4.023-.525.023a4.63,4.63,0,0,1-3.026-1A4.526,4.526,0,0,1,266.061,65.567Z",
    transform: "translate(-24596.328 -10943.078)",
    fill: "#1c1b1b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M183.922,92.048V71.476a1.434,1.434,0,0,1,1.434-1.434h.853V80.893c1.964-2.448,4.025-3.414,6.343-3.414a8.125,8.125,0,0,1,0,16.227,7.225,7.225,0,0,1-6.343-2.8v2.577h-.853A1.434,1.434,0,0,1,183.922,92.048Zm2.286-6.551c0,3.38,2.351,6.245,5.828,6.245a5.973,5.973,0,0,0,0-11.945A5.886,5.886,0,0,0,186.208,85.5Z",
    transform: "translate(-24612.393 -10938.366)",
    fill: "#1c1b1b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M214.459,89.334a7.638,7.638,0,0,1-6.311,3.058,8.074,8.074,0,0,1,0-16.131,7.654,7.654,0,0,1,6.311,3V76.391h2.254V92.3h-.82a1.433,1.433,0,0,1-1.434-1.432Zm-3.556.348a5.817,5.817,0,0,0,3.359-3.947,5.85,5.85,0,1,0-11.521-1.392A5.853,5.853,0,0,0,210.9,89.682Z",
    transform: "translate(-24609.158 -10937.148)",
    fill: "#1c1b1b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M230.185,76.478v1.385c-2.9,3.863-5.828,7.985-9.143,12.524h9.143v1.866H218.3V90.869c2.865-3.928,5.826-7.985,9.143-12.523H218.3V76.478Z",
    transform: "translate(-24605.666 -10937.106)",
    fill: "#1c1b1b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M244.454,89.334a7.642,7.642,0,0,1-6.312,3.058,8.074,8.074,0,0,1,0-16.131,7.657,7.657,0,0,1,6.312,3V76.391h2.253V92.3h-.82a1.432,1.432,0,0,1-1.432-1.432Zm-2.067-.524a4.422,4.422,0,0,0,1.2-1.371,5.877,5.877,0,1,0-1.2,1.371Z",
    transform: "translate(-24603.291 -10937.148)",
    fill: "#1c1b1b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M261.55,89.334a7.638,7.638,0,0,1-6.311,3.058,8.074,8.074,0,0,1,0-16.131,7.654,7.654,0,0,1,6.311,3V76.391H263.8V92.3h-.82a1.433,1.433,0,0,1-1.434-1.432Zm-1.7-.818a2.965,2.965,0,0,0,.569-.647,5.884,5.884,0,1,0-10.59-3.526C249.831,88.912,255.318,92.356,259.852,88.516Z",
    transform: "translate(-24599.945 -10937.148)",
    fill: "#1c1b1b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M267.616,76.477v3.283c1.707-2.574,3.574-3.445,5.538-3.445a5.337,5.337,0,0,1,1.417.161v1.868a4.613,4.613,0,0,0-1.352-.194,5.258,5.258,0,0,0-3.992,2c-1.642,2.028-1.514,4.636-1.611,7.148v4.926H265.4V77.911a1.433,1.433,0,0,1,1.434-1.434Z",
    transform: "translate(-24596.453 -10937.139)",
    fill: "#1c1b1b"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M193.372,66.1c-.2-.267-.368-.511-.509-.733a5.36,5.36,0,0,1-1.917,1.545l-.032.012a2.006,2.006,0,0,1-.908.181,2.412,2.412,0,0,1-2.208-1.452c-.02-.06-.043-.116-.06-.178-.01-.028-.018-.056-.026-.085a4.052,4.052,0,0,1-.095-.5c0-.059-.018-.115-.018-.175l0-.03c0-.044.011-.085.013-.129h-.02V60.768l-.01.007c.01-1.743.022-3.528.022-5.441v-9.4h-.82a1.434,1.434,0,0,0-1.434,1.434v6.1h-.008v1.868h.008c0,3.542.032,6.08.032,9.332a3.661,3.661,0,0,0,.022.427h0a5.165,5.165,0,0,0,.111.658c.011.045.012.091.024.138a4.359,4.359,0,0,0,.269.741,4.286,4.286,0,0,0,1.87,2.06,4.426,4.426,0,0,0,1.233.495c.035.008.068.008.1.016a4.313,4.313,0,0,0,.591.085c.1.008.189.011.283.013.164,0,.342,0,.536-.012.03,0,.062,0,.092,0h.027v0a4.6,4.6,0,0,0,2.748-1.343A1.418,1.418,0,0,0,193.372,66.1Z",
    transform: "translate(-24612.115 -10943.083)",
    fill: "#1c1b1b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbLogo);
export default __webpack_public_path__ + "static/media/tb-logo.4888e0d5488644b5ae091d06111e48df.svg";
export { ForwardRef as ReactComponent };